import * as ErrorBar from './ErrorBar';
import * as Sankey from './Sankey';
export default function () {
    Sankey.registerShape();
    ErrorBar.registerShape();
}
//# sourceMappingURL=loadShapes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_viser@2.4.9@viser/es/shapes/loadShapes.js
// module id = null
// module chunks = 